import { render } from "./emailComponent.vue?vue&type=template&id=26473946&scoped=true"
import script from "./emailComponent.vue?vue&type=script&lang=js"
export * from "./emailComponent.vue?vue&type=script&lang=js"

import "./emailComponent.vue?vue&type=style&index=0&id=26473946&scoped=true&lang=css"
import "./emailComponent.vue?vue&type=style&index=1&id=26473946&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26473946"]])

export default __exports__